(() => {
  // Shopify.currency.rate includes Shopify's 1.5% currency conversion fee; the shipping line at checkout doesn't.
  // Measured 2026-10-28: US$150 starts free delivery between A$212 and A$213 and between SAR 562 and SAR 564.
  const CONVERSION_FEE = 1.015;

  // Converts US cents into cart-currency cents, the way checkout converts the free-delivery line.
  const toLocalCents = (usdCents, currency) => {
    const cur = window.Shopify && window.Shopify.currency;
    if (!cur || cur.active !== currency) return null;
    const rate = Number(cur.rate);
    if (!(rate > 0)) return null;
    return rate === 1 ? usdCents : Math.round((usdCents * rate) / CONVERSION_FEE);
  };

  // Formats whole units like the store's own prices: the sample is 1000 in the cart currency, e.g. "$1,000" or "1.000 €".
  const formatter = (sample) => {
    const m = /1(\D?)000/.exec(sample || '');
    if (!m) return (units) => String(units);
    const sep = m[1];
    return (units) => sample.replace(m[0], String(units).replace(/\B(?=(\d{3})+(?!\d))/g, sep));
  };

  window.vcFreeShipToLocal = toLocalCents;
  window.vcFreeShipFormatter = formatter;

  if (customElements.get('vc-free-ship-bar')) return;
  customElements.define('vc-free-ship-bar', class extends HTMLElement {
    connectedCallback() {
      // On product pages this script loads before the side cart is parsed, so the bar's children may not exist yet.
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.render(), { once: true });
      } else {
        this.render();
      }
    }

    render() {
      const at = toLocalCents(Number(this.dataset.usdCents), this.dataset.currency);
      const text = this.querySelector('.wt-free-shipping-bar__text span');
      const fill = this.querySelector('.wt-progress-bar__fill');
      if (at === null || !text || !fill) return;
      const total = Number(this.dataset.total) || 0;
      const left = at - total;
      if (left > 0) {
        // Rounded up to a whole unit, so adding the amount shown always reaches the line.
        const amount = formatter(this.dataset.sample)(Math.ceil(left / 100));
        const tpl = this.dataset.text || '';
        const pos = tpl.indexOf('||amount||');
        if (pos < 0) {
          text.textContent = tpl;
        } else {
          const em = document.createElement('span');
          em.className = 'wt-free-shipping-bar__amount';
          em.textContent = amount;
          text.replaceChildren(tpl.slice(0, pos), em, tpl.slice(pos + '||amount||'.length));
        }
        fill.style.width = `${Math.round((total * 100) / at)}%`;
        this.classList.remove('wt-free-shipping-bar--done');
      } else {
        text.textContent = this.dataset.done || '';
        fill.style.width = '100%';
        this.classList.add('wt-free-shipping-bar--done');
      }
      this.hidden = false;
    }
  });
})();
